import { render, staticRenderFns } from "./devolucionProveedorTableComponent.vue?vue&type=template&id=4d47b414&"
import script from "./devolucionProveedorTableComponent.vue?vue&type=script&lang=js&"
export * from "./devolucionProveedorTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports